import Auth from './Auth';

// Helper function to append stored UTM parameters to a pathname
const appendStoredUTMs = (pathname) => {
  // Get stored UTMs from sessionStorage (preferred) or localStorage
  const utmSource =
    sessionStorage.getItem('utm_source') || localStorage.getItem('utm_source');
  const utmMedium =
    sessionStorage.getItem('utm_medium') || localStorage.getItem('utm_medium');
  const utmCampaign =
    sessionStorage.getItem('utm_campaign') ||
    localStorage.getItem('utm_campaign');

  // Build query string if we have any UTMs
  const params = new URLSearchParams();
  if (utmSource) params.set('utm_source', utmSource);
  if (utmMedium) params.set('utm_medium', utmMedium);
  if (utmCampaign) params.set('utm_campaign', utmCampaign);

  const queryString = params.toString();
  return queryString ? `${pathname}?${queryString}` : pathname;
};

const goToCart = (props) => {
  props.onCartUpdate();
  let fullUrl;
  if (Auth.isLoggedIn()) {
    fullUrl = appendStoredUTMs('/checkout/review');
  } else {
    fullUrl = appendStoredUTMs('/guest/checkout/review');
  }
  const [pathname, search] = fullUrl.split('?');
  props.history.push({ pathname, search: search ? `?${search}` : '' });
};

export default {
  goToCart,
  appendStoredUTMs,
};
